if (!customElements.get('conversation-lab-packages-pdp')) {
  class ConversationLabPackagesPdp extends HTMLElement {
    constructor() {
      super();
      this.swiper = null;
      this.desktopBreakpoint = 1024;
      this.handleResize = this.handleResize.bind(this);
    }

    connectedCallback() {
      this.handleResize();
      window.addEventListener('resize', this.handleResize);
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.handleResize);
      this.destroy();
    }

    get swiperContainer() {
      return this.querySelector('.conversation-lab-packages-pdp__slider');
    }

    getConfig() {
      return {
        slidesPerView: 1.08,
        spaceBetween: 12,
        grabCursor: true,
        keyboard: {
          enabled: true,
        },
        breakpoints: {
          768: {
            slidesPerView: 1.2,
            slidesPerGroup: 1,
            spaceBetween: 20,
          },
        },
      };
    }

    handleResize() {
      const isDesktop = window.innerWidth >= this.desktopBreakpoint;

      if (isDesktop) {
        this.destroy();
      } else if (!this.swiper) {
        this.init();
      }
    }

    init() {
      if (this.swiperContainer) {
        this.classList.add('slider-active');
        this.swiper = new Swiper(this.swiperContainer, this.getConfig());
      }
    }

    destroy() {
      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
      this.classList.remove('slider-active');
    }
  }

  customElements.define('conversation-lab-packages-pdp', ConversationLabPackagesPdp);
}
